/* eslint-disable @atlassian/i18n/no-literal-string-in-object */

// Note: Only English is supported for natural language search at this time.
// All query suggestions below are intentionally defined in English only.

// Google Drive
export const GOOGLE_DRIVE_STATIC_SUGGESTIONS: string[] = [
	'Show me my recent files',
	'List files I worked on recently',
	'Find files I edited this week',
	'Files I updated in the last 7 days',
	'My files from the last 14 days',
	'My files older than 2 months',
	'Show my files from this year',
	'Show me my recent Google docs',
	'My newest Google docs',
	'My Google docs from this week',
	'Google docs I worked on',
	'Google docs I updated yesterday',
];

export const GOOGLE_DRIVE_DYNAMIC_SUGGESTIONS: Array<(query: string) => string> = [
	(query) => `Show files about "${query}"`,
	(query) => `Recent files related to "${query}"`,
	(query) => `Show "${query}" files`,
	(query) => `"${query}" files`,
	(query) => `My "${query}" files from this week`,
	(query) => `My recent "${query}" files`,
	(query) => `List my "${query}" files`,
	(query) => `"${query}" files from this year`,
	(query) => `Show Google docs about "${query}"`,
	(query) => `Google docs related to "${query}"`,
	(query) => `"${query}" Google docs`,
	(query) => `My "${query}" Google docs`,
];
